import BaseApi from "@api/base.api";
import Http from "@services/http";

export default class UserApi extends BaseApi {
    static get entity() {
        return "users";
    }

    static async me(params = {}) {
        return await Http.get("me", params);
    }
    static superAdmin(params = {}) {
        return Http.get("superAdmin", params);
    }
    static async changePassword(params = {}) {
        return await Http.post("change-password", params);
    }

    static postSessionTime(params = {}) {
        return Http.post(`user/session/update`, params);
    }

    static getProjectApprovalsList(params = {}) {
        return Http.get("get-project-approvals", params);
    }

    static updateProjectApprovalsList(params = {}) {
        return Http.post(`post-project-approvals`, params);
    }


}
